import React, { useState } from 'react';
import { CheckCircle, XCircle, Send, Archive, Trash2, ChevronDown, X } from 'lucide-react';

const BulkActions = ({ selectedEntries, onBulkAction, userRole }) => {
  const [showBulkMenu, setShowBulkMenu] = useState(false);

  if (selectedEntries.length === 0) return null;

  const availableActions = [
    { action: 'approve', label: 'Approve Selected', icon: CheckCircle, color: 'green', roles: ['admin', 'manager'] },
    { action: 'reject', label: 'Reject Selected', icon: XCircle, color: 'red', roles: ['admin', 'manager'] },
    { action: 'submit', label: 'Submit Selected', icon: Send, color: 'blue', roles: ['admin', 'manager', 'user'] },
    { action: 'archive', label: 'Archive Selected', icon: Archive, color: 'gray', roles: ['admin', 'manager'] },
    { action: 'delete', label: 'Delete Selected', icon: Trash2, color: 'red', roles: ['admin'] }
  ].filter(action => action.roles.includes(userRole));

  return (
    <div className="fixed bottom-6 left-1/2 transform -translate-x-1/2 bg-white border border-slate-200 rounded-xl shadow-lg p-4 z-30">
      <div className="flex items-center space-x-4">
        <span className="text-sm font-medium text-slate-700">
          {selectedEntries.length} entries selected
        </span>
        
        <div className="relative">
          <button
            onClick={() => setShowBulkMenu(!showBulkMenu)}
            className="flex items-center space-x-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
          >
            <span>Bulk Actions</span>
            <ChevronDown className="w-4 h-4" />
          </button>

          {showBulkMenu && (
            <div className="absolute bottom-12 left-0 bg-white border border-slate-200 rounded-lg shadow-lg py-1 min-w-[160px]">
              {availableActions.map(({ action, label, icon: Icon, color }) => (
                <button
                  key={action}
                  onClick={() => {
                    onBulkAction(action, selectedEntries);
                    setShowBulkMenu(false);
                  }}
                  className={`w-full text-left px-3 py-2 text-sm hover:bg-slate-50 flex items-center ${
                    color === 'red' ? 'text-red-700' : 'text-slate-700'
                  }`}
                >
                  <Icon className="w-4 h-4 mr-2" />
                  {label}
                </button>
              ))}
            </div>
          )}
        </div>

        <button
          onClick={() => onBulkAction('clear', [])}
          className="text-slate-400 hover:text-slate-600"
        >
          <X className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
};

export default BulkActions;